<!-- TODO:AB AXB-696 HIDE THE USER SEGMENTS -->
<!-- TODO:MK AXB-884 CXB to UXB MERGE DISPLAY THE USER SEGMENTS -->
<ng-container *ngIf="currentPageActions$ | async as currentPageActions">
  <div *ngIf="currentPageActions.isUserSegmentEnabled" class="row d-flex align-items-center">
    <label class="col-6 required">User segments</label>
    <osn-cxb-multi-select
      class="col"
      *ngIf="userSegmentOptions"
      [isFixedWidth]="true"
      [formControl]="userSegmentIdsControl"
      [options]="userSegmentOptions"
      [errorLabel]="userSegmentIdsControl | missingUserSegmentSelectionPrompt"
      [emitValueOnRegisterOnChange]="emitValueOnRegisterOnChange"
      filterPlaceholderLabel="Filter in user segments..."
      filterNoEntriesFoundLabel="No user segment found"
      placeholder="Select target user types"
      [data-testid]="testId"
    ></osn-cxb-multi-select>
  </div>
</ng-container>
